// Moglee Base — scroll lock safety net.
//
// Panels (mobile menu, cart drawer, filter sheet, search) lock page scrolling
// while they are open. If the visitor navigates away with a panel open, or the
// phone restores the page from its back-forward cache, that lock can survive
// and the page looks frozen. This clears the lock on navigation and on restore.

(function () {
  var root = document.documentElement;

  function release() {
    document.body.style.overflow = '';
    root.removeAttribute('data-mb-menu-open');
    root.removeAttribute('data-mb-cart-open');

    document.querySelectorAll('[data-mb-sheet]').forEach(function (sheet) {
      sheet.setAttribute('data-open', 'false');
    });

    var search = document.querySelector('[data-mb-psearch]');
    if (search) search.setAttribute('data-open', 'false');

    var menu = document.querySelector('[data-mb-menu]');
    if (menu) menu.setAttribute('aria-hidden', 'true');
  }

  // Any link inside a panel: release the lock before the page changes.
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[href]');
      if (!link) return;
      if (!link.closest('[data-mb-menu], [data-mb-sheet], [data-mb-psearch], [data-mb-cart-drawer]')) return;
      if (link.getAttribute('href').charAt(0) === '#') return;
      release();
    },
    true
  );

  // Leaving the page, and coming back to it from the cache.
  window.addEventListener('pagehide', release);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) release();
  });
  window.addEventListener('popstate', release);

  // Last resort: if scrolling is locked but nothing is open, unlock it.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    var open =
      root.getAttribute('data-mb-menu-open') === 'true' ||
      root.getAttribute('data-mb-cart-open') === 'true' ||
      document.querySelector('[data-mb-sheet][data-open="true"]') ||
      document.querySelector('[data-mb-psearch][data-open="true"]');
    if (!open && document.body.style.overflow === 'hidden') release();
  });
})();
